module.exports = __webpack_public_path__ + "img/portrait-025.acd4f0b9.jpg";